import React from 'react'

export default function WhyChoseUs() {
    return (
        <div>
            <div className="container pt-5">
                <div className="row choseUs-bg d-flex align-items-center">
                    <div className="col-md-6 chose-col-bg">

                    </div>
                    <div
                        className="col-md-6"
                        data-aos="fade-up"
                        data-aos-duration="2000"
                    >
                        <h1> Why Choose Us? </h1>
                        <p className="my-3">
                            Our professional painting service can transform your home
                        </p>
                        <div className="about-head">
                            <h5>
                                {" "}
                                Quality Products
                            </h5>
                            <p> We pride ourselves on offering only the highest quality paints, tools, and accessories from trusted brands. With our carefully curated selection, you can achieve professional results that stand the test of time.</p>
                        </div>
                        <div className="about-head">
                            <h5>
                                {" "}
                                Expertise
                            </h5>
                            <p>Our team consists of seasoned professionals with years of experience in the painting industry. We're here to provide expert advice, personalized recommendations, and practical tips.</p>
                        </div>
                        <div className="about-head">
                            <h5>
                                {" "}
                                Convenience
                            </h5>
                            <p>With Home Painting, you can shop for all your painting supplies from the comfort of your home or office. Enjoy fast shipping and easy returns.</p>
                        </div>
                        <div className="about-head">
                            <h5>
                                {" "}
                                Customer Satisfaction
                            </h5>
                            <p>Your satisfaction is our top priority. From our user-friendly website to our dedicated customer support team, we're committed to providing you with an exceptional shopping experience from start to finish.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
